import { ExternalLink } from "lucide-react";
import { useMemo, useState, useEffect } from "react";

const STATUS_LABEL = {
  0: "Aguardando",
  1: "Preparando",
  2: "Liberado",
  3: "Entregue",
  4: "Finalizado",
  5: "Cancelado",
};

export default function OrderStatusLine({ order, onOpenModal }) {
  const [currentStep, setCurrentStep] = useState(order?.currentStep ?? 0);
  const totalSteps = order?.steps.length ?? 0;

  useEffect(() => {
    const rawStatus = localStorage.getItem("pedido.status");
    if (Number.isInteger(rawStatus)) {
      setCurrentStep(rawStatus);
    }
  }, [order]);

  const statusBadge = useMemo(() => {
    const i = Math.max(0, Math.min(totalSteps - 1, currentStep ?? 0));
    if (i === 0)
      return { text: STATUS_LABEL[0], cls: "bg-blue-100 text-blue-700" };
    if (i < totalSteps - 1)
      return { text: "Em andamento", cls: "bg-amber-100 text-amber-700" };
    return { text: "Concluído", cls: "bg-emerald-100 text-emerald-700" };
  }, [currentStep, totalSteps]);

  const currentStepInfo = useMemo(() => {
    if (!Array.isArray(order?.steps)) return { key: "", label: "—" };
    const step = order.steps[order.currentStep];
    return step ?? { key: "", label: "—" };
  }, [order.currentStep, order.steps]);

  return (
    <div className="fixed bottom-4 left-4 z-[99] order-status-line">
      <div
        onClick={onOpenModal}
        className="flex items-center gap-3 px-4 py-3 bg-white/95 backdrop-blur-sm shadow-lg rounded-full 
                   border border-gray-200 cursor-pointer hover:bg-white hover:shadow-xl 
                   transition-all duration-200 max-w-[calc(100vw-2rem)] sm:max-w-md"
      >
        {/* Indicador animado */}
        <span className="relative flex h-3 w-3 flex-shrink-0">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-3 w-3 bg-amber-500"></span>
        </span>

        {/* Conteúdo */}
        <div className="flex-1 min-w-0">
          <p className="text-xs font-semibold text-gray-900 truncate">
            Pedido #{order.id}
          </p>
          <p className="text-[10px] text-gray-600 truncate">
            {currentStepInfo.label}
          </p>
        </div>

        {/* Ícone de expandir */}
        <ExternalLink className="w-4 h-4 text-gray-500 flex-shrink-0" />
      </div>
    </div>
  );
}
